<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="53.66" height="53.66" viewBox="0 0 53.66 53.66">
  <g id="Schedule_Service" data-name="Schedule Service" transform="translate(-322.986 -307.996)">
    <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(323.486 308.496)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <g id="Group_8608" data-name="Group 8608" transform="translate(339.189 321.963)">
      <path id="Path_69785" data-name="Path 69785" d="M10.674,25.326H2.2a1.7,1.7,0,0,1-1.7-1.7V4.938a1.7,1.7,0,0,1,1.7-1.7H22.544a1.7,1.7,0,0,1,1.7,1.7v6.8" transform="translate(-0.5 -1.586)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_900" data-name="Line 900" x2="23.74" transform="translate(0 8.464)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_901" data-name="Line 901" y2="3.305" transform="translate(5.079)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_902" data-name="Line 902" y2="3.305" transform="translate(18.621)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <circle id="Ellipse_969" data-name="Ellipse 969" cx="6.61" cy="6.61" r="6.61" transform="translate(12.172 12.172)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_903" data-name="Line 903" y2="3.305" transform="translate(18.621 15.291)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_904" data-name="Line 904" x1="1.653" y1="1.653" transform="translate(18.653 18.653)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
